// Geometry shared by Select and the custom CRM pickers. Keep trigger widths
// independent: only the open overlay needs room for its option labels.
export const DROPDOWN_LAYOUT = Object.freeze({
  minWidth: 220,
  preferredWidth: 360,
  maxWidth: 640,
  viewportGap: 8,
  optionChrome: 76, // check/icon column, row padding, border and scrollbar
});

export function dropdownWidth({ triggerWidth, contentWidth = 0, minWidth = DROPDOWN_LAYOUT.minWidth, viewportWidth }) {
  const available = Math.max(0, viewportWidth - DROPDOWN_LAYOUT.viewportGap * 2);
  return Math.min(Math.max(triggerWidth, contentWidth, minWidth), DROPDOWN_LAYOUT.maxWidth, available);
}

export function dropdownLeft({ triggerLeft, width, viewportWidth }) {
  const gap = DROPDOWN_LAYOUT.viewportGap;
  return Math.max(gap, Math.min(triggerLeft, viewportWidth - width - gap));
}

// Zichtgrenzen voor een paneel onder `el`: het viewport, versmald door elke
// voorouder die overflow knipt (de paginakolom naast de zijbalk, een scrollende
// toolbar, een recordvenster). Alleen tegen het viewport klemmen liet een
// rechts-uitgelijnd menu achter de zijbalk verdwijnen zodra de kop omsloeg
// (bellijst, 29 sep 2026).
export function clipBounds(el, margin = DROPDOWN_LAYOUT.viewportGap) {
  let left = margin;
  let right = window.innerWidth - margin;
  let top = margin;
  let bottom = window.innerHeight - margin;
  for (let p = el?.parentElement; p && p !== document.body; p = p.parentElement) {
    const cs = window.getComputedStyle(p);
    if (cs.overflowX === 'visible' && cs.overflowY === 'visible') { if (cs.position === 'fixed') break; continue; }
    const r = p.getBoundingClientRect();
    if (cs.overflowX !== 'visible') { left = Math.max(left, r.left + 4); right = Math.min(right, r.right - 4); }
    if (cs.overflowY !== 'visible') { top = Math.max(top, r.top + 4); bottom = Math.min(bottom, r.bottom - 4); }
    if (cs.position === 'fixed') break;
  }
  return { left, right, top, bottom };
}

// For menus positioned inside a relative trigger wrapper rather than a portal.
// `bounds` ({ left, right }, zie clipBounds) vervangt de viewportranden.
export function dropdownAbsolutePosition(anchorRect, viewportWidth, contentWidth = DROPDOWN_LAYOUT.preferredWidth, bounds = null) {
  if (!anchorRect) return { left: 0, width: contentWidth };
  const gap = DROPDOWN_LAYOUT.viewportGap;
  const lo = bounds ? bounds.left : gap;
  const hi = bounds ? bounds.right : viewportWidth - gap;
  const width = Math.min(dropdownWidth({ triggerWidth: anchorRect.width, contentWidth, viewportWidth }), Math.max(0, hi - lo));
  return { left: Math.max(lo, Math.min(anchorRect.left, hi - width)) - anchorRect.left, width };
}
